import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Cart } from '../cart.model';
import { AssignmentProposal } from '../assignment-proposal.model';
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-assignment-proposal-answer-dialog',
  templateUrl: './assignment-proposal-answer-dialog.component.html',
  styleUrls: ['./assignment-proposal-answer-dialog.component.css']
})
export class AssignmentProposalAnswerDialogComponent implements OnInit {

  loading = false;

  constructor(
    private dialogRef: MatDialogRef<AssignmentProposalAnswerDialogComponent>,
    private angularFireFunctions: AngularFireFunctions,
    @Inject(MAT_DIALOG_DATA) public data: { cart: Cart, proposal: AssignmentProposal }) { }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

  async answer(answer: boolean) {
    // TODO: spinner
    this.loading = true;
    const assignmentProposalApi = this.angularFireFunctions.httpsCallable('assignmentProposalApi');
    try {
      await assignmentProposalApi({
        id: this.data.proposal.id,
        itinerary: this.data.proposal.itinerary.id,
        answer
      }).toPromise();
      this.dialogRef.close(answer);
    } catch (error) {
      // TODO: show error
      this.loading = false;
      console.error(error);
      alert(error);
    }
  }

}
